import { render, staticRenderFns } from "./HealthCheck45PsaThyroidNR.vue?vue&type=template&id=769c7b9e&scoped=true&"
import script from "./HealthCheck45PsaThyroidNR.vue?vue&type=script&lang=js&"
export * from "./HealthCheck45PsaThyroidNR.vue?vue&type=script&lang=js&"
import style0 from "./HealthCheck45PsaThyroidNR.vue?vue&type=style&index=0&id=769c7b9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769c7b9e",
  null
  
)

export default component.exports